import type { ComboboxItem } from '@mantine/core';

export interface RjsfEnumOption {
  value: unknown;
  label: string;
}

const enumOptionValueToCanonicalString = (raw: unknown): string => {
  if (raw === undefined || raw === null || raw === '') {
    return '';
  }
  if (typeof raw === 'string') {
    return raw;
  }
  if (
    typeof raw === 'number' ||
    typeof raw === 'boolean' ||
    typeof raw === 'bigint'
  ) {
    return String(raw);
  }
  if (typeof raw === 'object') {
    return JSON.stringify(raw);
  }
  return '';
};

const prependValueToString = (raw: unknown): string | undefined => {
  if (raw === undefined || raw === null || raw === '') {
    return undefined;
  }
  if (
    typeof raw === 'object' ||
    typeof raw === 'function' ||
    typeof raw === 'symbol'
  ) {
    return undefined;
  }
  if (typeof raw === 'string') {
    return raw;
  }
  if (
    typeof raw === 'number' ||
    typeof raw === 'boolean' ||
    typeof raw === 'bigint'
  ) {
    return String(raw);
  }
  return undefined;
};

export const mapEnumOptionsToComboboxItems = (
  enumOptions: RjsfEnumOption[],
  resolveDisplayLabel: (canonicalValue: string) => string
): ComboboxItem[] =>
  enumOptions.map((option) => {
    const canonicalValue = enumOptionValueToCanonicalString(option.value);
    return {
      value: canonicalValue,
      label: resolveDisplayLabel(canonicalValue),
    };
  });

export const prependComboboxItemWhenValueMissing = (
  items: ComboboxItem[],
  value: unknown,
  resolveLabelForUnknownValue: (valueString: string) => string
): ComboboxItem[] => {
  const valueString = prependValueToString(value);
  if (valueString === undefined) {
    return items;
  }
  if (items.some((item) => item.value === valueString)) {
    return items;
  }
  return [
    { value: valueString, label: resolveLabelForUnknownValue(valueString) },
    ...items,
  ];
};
